module.exports = __webpack_public_path__ + "static/media/bannerContactanos.f28a971a.png";